export const createUniqueIDFactory = (prefix: string) => {
  let count = 0;
  return () => `${prefix}${count++}`;
};
